/**
 * Ищет последний индекс элемента, удовлетворяющего заданному условию, в массиве.
 *
 * @param array Массив, в котором нужно найти элемент.
 * @param predicate Условие, которому должен удовлетворять элемент.
 * @typeParam T Тип элементов в массиве
 * @returns Последний индекс элемента, удовлетворяющего условию, или -1, если такого элемента нет.
 *
 * @example
 * ```typescript
 * import { findLastIndex } from '@direct-frontend/stdlib';
 *
 * const array = [1,2,3,4,5];
 * const isEven = (el: number) => el % 2 === 0;
 * const isTen = (el: number) => el === 10;
 *
 * findLastIndex(array, isEven) // 3
 * findLastIndex(array, isTen) // -1
 * ```
 */
export function findLastIndex(array, predicate) {
    for (let i = array.length - 1; i >= 0; i--) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- в этом месте не может быть переполнения
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
